// src/slices/8-Contact-us/reducer.js
import { createSlice } from "@reduxjs/toolkit";
import { sendContact } from "./thunk";
const contactReducer = createSlice({
  name: "contact",
  initialState: { loading: false, success: false, error: null, data: null },
  reducers: {
    resetContact: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.data = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendContact.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(sendContact.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.data = action.payload;
      })
      .addCase(sendContact.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      });
  }
});

export const { resetContact } = contactReducer.actions;
export default contactReducer.reducer;
